import React from 'react'
import PricingForm from '~/components/organisms/PricingForm'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import { BoldTailHeading } from '~/utils/boldTailHeading'
import './HeroPricing.css'
import { trustpilotLinkProps } from '~/data/trustpilot'

export default function HeroPricing({ index, ...props }) {
  const section = props.heroPricing

  return (
    <section
      id={section.fieldGroupName + index}
      className="hero-pricing-section hero-contact-padding pb-16 md:pb-20"
    >
      <div className="container">
        <div className="hero-pricing-inner">

          {/* Text column — heading, description */}
          <div className="hero-pricing-text-col">
            {(section?.textCard?.heading?.text || section?.textCard?.content) && (
              <div className="hero-pricing-heading-wrap">
                {section?.textCard?.heading?.text && (
                  <h1 className="hero-pricing-heading">
                    <BoldTailHeading text={section.textCard.heading.text} />
                  </h1>
                )}
                {section?.textCard?.content && (
                  <div
                    className="hero-pricing-subtext"
                    dangerouslySetInnerHTML={{
                      __html: section.textCard.content.replace(
                        /free rental market appraisal report\./gi,
                        '<strong style="text-decoration:underline;text-decoration-style:solid;text-decoration-skip-ink:none;">free rental market appraisal report.</strong>'
                      )
                    }}
                  />
                )}
              </div>
            )}
          </div>

          {/* Form column — form card, then trust badges below the CTA */}
          <div className="hero-pricing-form-col">
            <FadeInWhenVisible>
              <div className="hero-pricing-card">
                <PricingForm language={section?.language ?? 'en'} />
              </div>
            </FadeInWhenVisible>

            <div className="hero-pricing-trust-row">
              <div className="hero-pricing-rating">
                <strong>4.7/5</strong>
                <span>(2,000+ reviews)</span>
              </div>

              <a {...trustpilotLinkProps} style={{ display: 'block' }} dangerouslySetInnerHTML={{
                __html: `
                  <svg width="86" height="46" viewBox="0 0 86 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.000976562 28.4551H16.1256V44.5797H0.000976562V28.4551ZM17.4693 28.4551H33.594V44.5797H17.4693V28.4551ZM34.9377 28.4551H51.0623V44.5797H34.9377V28.4551ZM52.406 28.4551H68.5306V44.5797H52.406V28.4551ZM69.8744 28.4551H85.999V44.5797H69.8744V28.4551Z" fill="#00B67A" opacity="0.3"/>
                    <path d="M0.000976562 28.4551H16.1256V44.5797H0.000976562V28.4551ZM17.4693 28.4551H33.594V44.5797H17.4693V28.4551ZM34.9377 28.4551H51.0623V44.5797H34.9377V28.4551ZM52.406 28.4551H68.5306V44.5797H52.406V28.4551ZM69.8744 28.4551H83.1002V44.5797H69.8744V28.4551Z" fill="#00B67A"/>
                    <path d="M8.06354 39.3223L10.5158 38.7009L11.5404 41.8586L8.06354 39.3223ZM13.7072 35.2408H9.39046L8.06354 31.176L6.73662 35.2408H2.41992L5.91359 37.7602L4.58667 41.825L8.08034 39.3055L10.2303 37.7602L13.7072 35.2408ZM25.5319 39.3223L27.9842 38.7009L29.0088 41.8586L25.5319 39.3223ZM31.1755 35.2408H26.8588L25.5319 31.176L24.205 35.2408H19.8883L23.3819 37.7602L22.055 41.825L25.5487 39.3055L27.6986 37.7602L31.1755 35.2408ZM43.0002 39.3223L45.4525 38.7009L46.4771 41.8586L43.0002 39.3223ZM48.6439 35.2408H44.3272L43.0002 31.176L41.6733 35.2408H37.3566L40.8503 37.7602L39.5234 41.825L43.017 39.3055L45.167 37.7602L48.6439 35.2408ZM60.4686 39.3223L62.9209 38.7009L63.9455 41.8586L60.4686 39.3223ZM66.1122 35.2408H61.7955L60.4686 31.176L59.1417 35.2408H54.825L58.3186 37.7602L56.9917 41.825L60.4854 39.3055L62.6353 37.7602L66.1122 35.2408ZM77.9369 39.3223L80.3892 38.7009L81.4138 41.8586L77.9369 39.3223ZM83.5806 35.2408H79.2639L77.9369 31.176L76.61 35.2408H72.2933L75.787 37.7602L74.4601 41.825L77.9537 39.3055L80.1037 37.7602L83.5806 35.2408Z" fill="#12203A"/>
                    <text x="0" y="16" font-family="Untitled Sans, sans-serif" font-size="13" font-weight="500" fill="#12203A">Trustpilot</text>
                  </svg>
                `
              }} />

              <div className="hero-pricing-badge">
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0C5.5 2.8 1 8.4 1 12.5a7 7 0 0014 0C15 8.4 10.5 2.8 8 0zm0 17.5a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z" fill="#FF5A5F"/>
                </svg>
                <div>
                  <div className="hero-pricing-badge-title">airbnb</div>
                  <div className="hero-pricing-badge-subtitle">superhost</div>
                </div>
              </div>

              <div className="hero-pricing-properties">
                350+ Properties Managed
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
